// Module
var code = "<template>\n  <div style=\"width: 100%; height: 100%; position: relative\" id=\"map\" class=\"map\">\n    <div id=\"map-menu\" class=\"map-menu\">\n      <mn-button variant=\"primary\" on-click.call=\"resetCenter()\">Center</mn-button>\n    </div>\n  </div>\n</template>\n";
// Exports
export default code;